import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import ProfileCard from "./components/ProfileCard";
import Locations from "./pages/Locations";
import WhatsApp from "./pages/WhatsApp";
import "./App.css";

function App() {
  // Función para abrir WhatsApp
  const openWhatsApp = (phone) => {
    const cleanedPhone = phone.replace(/\D/g, '');
    window.open(`https://wa.me/${cleanedPhone}`, '_blank');
  };

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={
          <>
            <ProfileCard 
              name="CLIC Pilates" 
              bio="Bienvenido a nuestros enlaces oficiales" 
            />
            
            {/* Sección de botones principales */}
            <div className="button-section">
              <Link to="/ubicaciones" className="link-button">
                📍 Ubicaciones
              </Link>
              
              <Link to="/whatsapp" className="link-button">
                💬 WhatsApp
              </Link>
              
              <Link 
                onClick={() => openWhatsApp('+54 9 11 2519-0076')} 
                className="link-button unified-button"
              >
                🏢 Franquicias
              </Link>
              
              <Link 
                onClick={() => openWhatsApp('+54 9 11 2519-0076')} 
                className="link-button unified-button"
              >
                🎓 Instructorado
              </Link>
            </div>

            {/* Sección de descarga de app */}
            <div className="download-section">
              <h3>Descarga nuestra app</h3>
              <a
                href="https://play.google.com/store/apps/details?id=deportnet.apps.clicfit"
                target="_blank"
                rel="noopener noreferrer"
                className="download-button"
              >
                <img 
                  src="/img/google-play.png" 
                  alt="Disponible en Google Play" 
                />
              </a>
              <a
                href="https://apps.apple.com/us/app/clic-fit/id6642709263"
                target="_blank"
                rel="noopener noreferrer"
                className="download-button"
              >
                <img 
                  src="/img/app-store.svg" 
                  alt="Descargar en App Store" 
                />
              </a>
            </div>
          </>
        } />
        
        {/* Rutas para páginas secundarias */}
        <Route path="/ubicaciones" element={<Locations />} />
        <Route path="/whatsapp" element={<WhatsApp />} />
      </Routes>
    </div>
  );
}

export default App;